import {PrescriptionsTab} from '@/modules/reports/components/prescriptions-tab'
import {StockMovementsTab} from '@/modules/reports/components/stock-movements-tab'
import {ReportsSearchSchema, type ReportsTab} from '@/modules/reports/schemas'
import {Box, Heading} from '@chakra-ui/react'
import {useAppForm} from '@cypro/ui/integrations/form'
import {useStore} from '@tanstack/react-form'
import {createFileRoute, useNavigate} from '@tanstack/react-router'
import {useTranslate} from '@tolgee/react'

const TABS: {key: ReportsTab; labelKey: string}[] = [
  {key: 'prescriptions', labelKey: 'tab_prescriptions'},
  {key: 'stockMovements', labelKey: 'tab_stock_movements'},
]

export const Route = createFileRoute('/reports/')({
  component: ReportsIndex,
  validateSearch: ReportsSearchSchema,
})

function ReportsIndex() {
  const {t} = useTranslate('reports')
  const {t: tCommon} = useTranslate('common')
  const navigate = useNavigate()
  const search = Route.useSearch()

  const form = useAppForm({
    defaultValues: {tab: search.tab},
    listeners: {
      onChange({formApi}) {
        // views belong to one tab, so switching tabs drops the open view
        navigate({to: '/reports', search: {...search, tab: formApi.state.values.tab, view: undefined}})
      },
    },
  })
  const tab = useStore(form.store, state => state.values.tab)
  const isStockMovements = tab === 'stockMovements'

  return (
    <Box display="flex" flexDirection="column" flex="1 1 0%" minH={0} height="100%">
      <Box py={{base: '2', md: '3.5'}} flexShrink={0}>
        <Heading as="h1" textStyle="2xl">
          {tCommon('reports')}
        </Heading>
      </Box>

      <form.AppField name="tab">
        {field => (
          <field.TabsField
            tabs={TABS.map(item => ({key: item.key, trigger: t(item.labelKey)}))}
            display="flex"
            flexDirection="column"
            flex="1 1 0%"
            minH={0}
          >
            <PrescriptionsTab enabled={!isStockMovements} />
            <StockMovementsTab enabled={isStockMovements} />
          </field.TabsField>
        )}
      </form.AppField>
    </Box>
  )
}
